import React from "react";
import { MdGavel } from "react-icons/md";
import { Trans, useTranslation } from "react-i18next";
import { LEGAL_PATHS } from "../../../../../../Components/Auth/Legal/legalRules";

// The links open the in-app legal pages in the reader's language.
const LegalNotice = () => {
  const { t, i18n } = useTranslation("settings");
  const lang = i18n.resolvedLanguage === "fr" ? "fr" : "en";
  return (
    <div className="flex gap-2.5 rounded-[10px] border-[1px] border-ui-border bg-ui-surface px-[12px] py-[12px] sm:px-4 sm:py-3.5">
      <MdGavel className="mt-px h-4 w-4 flex-none text-ui-text-muted" />
      <div className="flex flex-col gap-1.5 text-[11px] leading-[1.6] text-state-neutral-text">
        <strong className="text-xs font-semibold text-ui-text">
          {t("marketplaces.legal.title")}
        </strong>
        <span>{t("marketplaces.legal.trademarks")}</span>
        <span>{t("marketplaces.legal.availability")}</span>
        <span>
          <Trans
            t={t}
            i18nKey="marketplaces.legal.links"
            components={{
              terms: (
                // eslint-disable-next-line jsx-a11y/anchor-has-content -- the text comes from the translation
                <a
                  href={LEGAL_PATHS.terms[lang]}
                  target="_blank"
                  rel="noreferrer"
                  className="text-brand"
                />
              ),
              privacy: (
                // eslint-disable-next-line jsx-a11y/anchor-has-content -- the text comes from the translation
                <a
                  href={LEGAL_PATHS.privacy[lang]}
                  target="_blank"
                  rel="noreferrer"
                  className="text-brand"
                />
              ),
              mail: (
                <a href="mailto:legal@hajexbolt.com" className="text-brand">
                  legal@hajexbolt.com
                </a>
              ),
            }}
          />
        </span>
      </div>
    </div>
  );
};

export default LegalNotice;
